import { createStore, combineReducers } from 'redux';
import globalReducer from '../reducers/globalReducer';

const rootReducer = combineReducers({
    globalReducer,
});

const store = createStore(rootReducer);

export default store;